import { Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

import { MatTableDataSource } from '@angular/material/table';
import { Manufacturer } from 'src/typings';
import { CreateManufacturerComponent } from '../create-manufacturer/create-manufacturer.component';
import { ManufacturerService } from '../manufacturer.service';

@Component({
  selector: 'app-manufacturer-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ManufacturerListComponent {
  manufacturers: Manufacturer[] = [];

  filteredList = new MatTableDataSource<Manufacturer>();

  length: number | undefined;

  descriptionControl: UntypedFormControl = new UntypedFormControl();

  displayedColumns: string[] = ['id', 'description'];

  constructor(private manufacturerService: ManufacturerService, private dialog: MatDialog) {
    this.search();
    this.manufacturerService.manufacturerGW.subscribe(() => {
      this.search();
    });
    this.descriptionControl.valueChanges.subscribe((value) => {
      this.filterManufacturers(value);
    });
  }

  search() {
    this.manufacturerService.search().subscribe((list) => {
      this.manufacturers = list.data;
      this.filteredList.data = list.data;
      this.length = Number(list.length);
    });
  }

  filterManufacturers(payload: string) {
    this.filteredList.data = this.manufacturers.filter((manufacturer) => {
      return manufacturer.description.toUpperCase().includes(payload.toUpperCase());
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filteredList.data = this.manufacturers.filter((row) => {
      return row.description.toUpperCase().includes(filterValue.toUpperCase());
    });
  }

  add() {
    const dialogRef = this.dialog.open(CreateManufacturerComponent);
    dialogRef.componentInstance.dialogRef = dialogRef;
    dialogRef.componentInstance.createEvent.subscribe(() => {
      this.search();
    });
  }
}
